import React from "react";
import { Button } from "../../shadcn/button";

const SecondaryButton = ({
  icon,
  text,
  disabled,
  onClick,
  style,
  className,
  ref,
  variant = "error", // options: "error" (red), "neutral" (gray), "brandTint" (brand/50)
  ...props
}) => {
  let variantClasses = "bg-error-100 text-error-700 border-error-100";
  if (variant === "neutral") {
    variantClasses = "bg-white text-gray-700 border-gray-300 hover:bg-gray-50";
  } else if (variant === "brandTint") {
    // Brand/50 background with Brand/50 border and brand text
    variantClasses = "bg-brand-50 text-brand-700 border-brand-50";
  }

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      ref={ref}
      className={`${variantClasses} border font-inter font-semibold text-sm leading-5 tracking-normal px-4 py-2.5 rounded-lg inline-flex items-center justify-center gap-2 w-fit transition-all duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed ${className ?? ""}`}
      style={{
        // Exact shadow per spec: 0 1px 2px 0 rgba(10, 13, 18, 0.05)
        boxShadow: "0 1px 2px 0 rgba(10, 13, 18, 0.05)",
        // Ensure Inter font even with global * selector
        fontFamily: "Lato, sans-serif",
        ...style,
      }}
      {...props}
    >
      {icon}
      {text}
    </Button>
  );
};

export default SecondaryButton;
